import { Component } from '@angular/core';



import { NavController, NavParams } from 'ionic-angular';
import { CategoriePage } from '../categorie/categorie';
import { ManifestiPage } from '../manifesti/manifesti';
import { RicercaPage } from '../ricerca/ricerca';
import { NotificaPage } from '../notifica/notifica';
import { OttimizzaPage } from '../ottimizza/ottimizza';
import { CommissionePage } from '../commissione/commissione';

import { CategoriemenuPage } from '../categoriemenu/categoriemenu';
import { RicercamenuPage } from '../ricercamenu/ricercamenu';
import { MessaggioPage } from '../messaggio/messaggio';
import {CouponPage} from "../coupon/coupon";
import {ScontiPage} from "../sconti/sconti";



@Component({
  selector: 'page-prodotti',
  templateUrl: 'prodotti.html',
})


export class ProdottiPage {





  constructor(public nav: NavController) {



  }
  openSconti(){
    this.nav.push(ScontiPage);

  }

  openCouponPage(){
    this.nav.push(CouponPage);

  }
  openRicercaMenuPage(){
    this.nav.push(RicercamenuPage);

  }
  openRicercaPage() {

    this.nav.push(RicercaPage);

  }
  openCategoriePage() {

    this.nav.push(CategoriePage);

  }
  openManifestiPage() {

    this.nav.push(ManifestiPage);

  }
  openCategorieMenuPage() {
    this.nav.push(CategoriemenuPage);

  }
  openNotifica(){
    this.nav.push(NotificaPage);

  }
  openOttimizza(){
    this.nav.push(OttimizzaPage);

  }
  openSms(){
    this.nav.push(MessaggioPage);

  }
  openCommissione(){
    this.nav.push(CommissionePage);

  }
  
  
}


// WEBPACK FOOTER //
// ./src/pages/prodotti/prodotti.ts